import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";

export const EntryPolicyControls = ({ value, busy, onSave }) => {
  const [draft, setDraft] = useState(value || "0.50");
  useEffect(() => setDraft(value || "0.50"), [value]);

  const submit = (event) => {
    event.preventDefault();
    onSave(draft);
  };

  return <form className="entry-policy-controls" onSubmit={submit}
    data-testid="reference-entry-policy-form">
    <label htmlFor="reference-entry-tolerance" data-testid="reference-entry-tolerance-label">
      REFERENCE_ENTRY 不利偏差容忍度
      <span data-testid="reference-entry-tolerance-help">仅作用于不利价格，允许范围 0.10%–2.00%</span>
    </label>
    <div className="entry-policy-input-wrap">
      <input id="reference-entry-tolerance" type="number" min="0.10" max="2.00"
        step="0.01" required value={draft} disabled={busy}
        onChange={(event) => setDraft(event.target.value)}
        data-testid="reference-entry-tolerance-input" />
      <span aria-hidden="true">%</span>
    </div>
    <Button variant="secondary" type="submit" disabled={busy}
      data-testid="save-reference-entry-tolerance-button">
      <Save aria-hidden="true" />保存参数
    </Button>
    <b className="mono" data-testid="reference-entry-tolerance-current">
      当前：{value || "0.50"}%
    </b>
  </form>;
};